import React, {useState, useEffect} from 'react';

import ProductTag from 'web/components/product_tag';
import assetPath from 'web/helpers/asset_path';

const ProductImagesCarousel = ({
  images,
  autoPlay = true,
  interval = 3000,
  productTagData = {promoPrice: 0, basePrice: 0, isPromotional: false},
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying] = useState(autoPlay);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    let slideInterval;
    if (isAutoPlaying) {
      slideInterval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
      }, interval);
    }
    return () => clearInterval(slideInterval);
  }, [currentIndex, isAutoPlaying, interval]);

  return (
    <div className="carousel">
      {productTagData.isPromotional && (
        <ProductTag
          promoPrice={productTagData.promoPrice}
          basePrice={productTagData.basePrice}
          size="lg"
        />
      )}
      <div className="carousel-inner" style={{transform: `translateX(-${currentIndex * 100}%)`}}>
        {images.map((image, index) => (
          <div key={index} className="carousel-item">
            <img src={image.url} alt={image.alt} data-src-large={image.url} />
          </div>
        ))}
      </div>

      {currentIndex > 0 && (
        <button
          type="button"
          className={`carousel-control prev ${isMobile ? 'mobile' : ''}`}
          onClick={prevSlide}
          aria-label="Previous slide"
        >
          <img
            data-testid="carousel-arrow-left"
            src={`${assetPath(
              `/img/svg/icons/arrow-left-${isMobile ? 'mobile' : 'desktop'}.svg`,
            )}?auto=format`}
            style={{cursor: 'pointer'}}
          />
        </button>
      )}
      {currentIndex < images.length - 1 && (
        <button
          type="button"
          className={`carousel-control next ${isMobile ? 'mobile' : ''}`}
          onClick={nextSlide}
          aria-label="Next slide"
        >
          <img
            data-testid="carousel-arrow-right"
            src={`${assetPath(
              `/img/svg/icons/arrow-right-${isMobile ? 'mobile' : 'desktop'}.svg`,
            )}?auto=format`}
            style={{cursor: 'pointer'}}
          />
        </button>
      )}

      <div className={`carousel-dots ${isMobile ? 'mobile' : ''}`}>
        {images.map((_, index) => (
          <button
            type="button"
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductImagesCarousel;
